<div class="reports">
    <p class="label">{{'admin.strain.registry.details.measurements.reports' | translate}}</p>
    <ng-container
        *ngTemplateOutlet="measurement?.reports && measurement?.reports?.length ? reports : noReports; context: { reports: measurement.reports }">
    </ng-container>
</div>
<ng-template #reports let-reports="reports">
    <ng-container *ngFor="let report of reports">
        <app-link
            *ngIf="report.initial"
            icon="fa-file-text"
            (clicked)="onReportClick(report)"
        >{{'admin.strain.registry.details.measurements.downloadInitialReport' | translate }}
        </app-link>
        <app-link
            *ngIf="!report.initial"
            (clicked)="onReportClick(report)"
            icon="fa-file-text">{{ 'admin.strain.registry.details.measurements.downloadRegeneratedReport' | translate : {date: report.createdAt} }}
        </app-link>
    </ng-container>
</ng-template>

<ng-template #noReports>{{'admin.strain.registry.details.measurements.noReports' | translate}}</ng-template>
